module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("区域在售登记种类")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../../assets/img/trp/top.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, _vm._l((_vm.type), function(item, key, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('p', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item))])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title1"
  }, [_vm._v("近30天区域店铺台账信息")]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('p', [_vm._v("总交易量（笔）")]), _vm._v(" "), _c('p', [_vm._v("21")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bar2"
  }, [_c('div', {
    staticClass: "main"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e7baefa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/yinxiao/components/salesData/index.vue
// module id = 1986
// module chunks = 2